<template>
  <div id="app" :style="scales">
    <router-view/>
  </div>
</template>

<script>
import $ from 'jquery';
export default {
    name: 'App',
    data(){
        return {
            scales:{
                transform:"",
                screenWidth:0
            }
        };
    },
    methods:{
        pageResize(){
            let height=window.innerHeight/948;
            let width=window.innerWidth/1920;
            this.scales.transform='scaleX('+width+') scaleY('+height+')';
        },
        isMainPage (path) {
            if (path === '/indexPage' || path === "/") {
                /*如果是首页*/
                let that = this;
                this.$nextTick(()=> {
                    $('body').css({
                        "overflow": 'hidden'
                    });
                    $('body, html').css({
                        "min-height": "unset",
                        "height": '100%'
                    });
                    if (that.screenWidth >=1200) {
                        $(".footer-style").css({
                            "position": 'absolute',
                            "left": 0,
                            "bottom": 0,
                            "width": '100%'
                        });
                    } else {
                        $(".footer-style").css({
                            "position": 'unset',
                            "left": 0,
                            "bottom": 0,
                            "width": '100%'
                        });
                    }
                });
            } else {
                this.$nextTick(()=> {
                    $('body').css({
                        "overflow-x": 'hidden',
                        "overflow-y": 'unset'
                    });
                    $('body, html').css({
                        "min-height": "100%",
                        "height": 'unset'
                    });
                });
            }
        }
    },
    mounted () {
        let that = this;
        that.screenWidth = document.documentElement.clientWidth;
        this.isMainPage(this.$route.path);
        $(window).bind('resize',function () {
            that.screenWidth = document.documentElement.clientWidth;
            that.isMainPage(that.$route.path);
        });
        //禁止双指放大
        document.documentElement.addEventListener('touchstart', function (event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        }, false);
        //禁止双击放大
        let lastTouchEnd = 0;
        document.documentElement.addEventListener('touchend', function (event) {
            let now = Date.now();
            if (now - lastTouchEnd <= 300) {
                event.preventDefault();
            }
            lastTouchEnd = now;
        }, false);
    },
    watch: {
        '$route.path' (newVal) {
            this.isMainPage(newVal);
        }
    }
    // beforeMount(){
    //   this.pageResize();
    // },
};
</script>

<style lang="less">
  @import "./assets/css/phone.less";
*{
  margin:0;
  padding:0;
}
html,body{
  width:100%;
  height:100%;
  /* transform-origin:0 0 ; */
  /*overflow: hidden;*/
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
    width:100%;
  height:100%;
    overflow-x: hidden;
    overflow-y: hidden;
  /* width:100%; */
  /* width:1920px;
  height:948px;
  transform-origin:0 0 ; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue